
import { SET_HEADER_HEIGHT, SET_LAYOUT_WIDTH, SET_NAV_LOGO_MARGIN_WIDTH } from "../Types";

export const setHeaderHeight = (height) => ({
  type: SET_HEADER_HEIGHT,
  payload: height,
});

export const setLayoutWidth = (width) => ({
  type: SET_LAYOUT_WIDTH,
  payload: width,
});

export const setNavLogoMargin = (margin) => ({
  type: SET_NAV_LOGO_MARGIN_WIDTH,
  payload: margin,
});